import { Input } from '@aon/aon-tws-common-ui';
import { ColHalves } from '@aon/tws-common-ui-questions';
import { InnerSectionContainer } from '@aon/tws-common-ui-questions/build/lib/components/questions/custom-questions';
import * as React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import {
	CustomQuestionPropertyUnderValidation,
	ICustomResponseOptionEditModel,
	IValidationCollection,
	QuestionType,
} from '../../../models';
import { ValidationCollectionHelper } from '../../../utilities';
import { ColFull, Section } from '../../common';
import { CustomResponseOptionGroupRankingToggle } from './CustomResponseOptionGroupRankingToggle';
import { CustomResponseOptionGroupToggle } from './CustomResponseOptionGroupToggle';
import { CustomResponseOptionTableContainer } from './CustomResponseOptionTable';

export const LeftAlignDiv = styled.div`
	width: 100%;
	text-align: left;
`;
LeftAlignDiv.displayName = 'LeftAlignDiv';

export interface ICustomResponseOptionsSectionProps {
	responseOptions: ICustomResponseOptionEditModel[];
	name: string;
	validationResults?: IValidationCollection;
	isDemographic?: boolean;
	questionType?: QuestionType;
	isMultiple?: boolean;
	sectionContainer?: any;
	HandleFollowUpCheck: (responseOptionId: number) => void;
	UpdateCustomResponseOptionsOrder: (ids: number[]) => void;
	UpdateCustomResponseOptionValue: (value: number | '', responseOptionId: number) => void;
	UpdateCustomResponseOptionGroupName: (value: string | '') => void;
	UpdateCustomResponseOptionText: (text: string, cultureCode: string, responseOptionId: number) => void;
	AddResponseOption: () => void;
	DeleteResponseOption: (responseOptionId: number) => void;
}

export const ResponseOptionsWrapper = styled('div').attrs<{}>({
	className: 'tws-custom-response-options-selector',
})`
	margin: 40px 0;
`;

export const ResponseOptionGroupNameInput = styled(Input).attrs<any>({
	className: 'tws-custom-question-response-option-group',
})`
	&&.tws-custom-question-response-option-group {
		width: 200px;
	}
`;

const TogglesContainer = styled.div`
	margin-top: 10px;
	display: flex;
	justify-content: flex-end;
`;
TogglesContainer.displayName = 'TogglesContainer';

export class CustomResponseOptionsSection extends React.Component<ICustomResponseOptionsSectionProps> {
	public render() {
		const { isDemographic, sectionContainer, validationResults, questionType, isMultiple } = this.props;

		const validationHelper = new ValidationCollectionHelper<CustomQuestionPropertyUnderValidation>(validationResults);
		const responseOptionsValidation = validationHelper.GetValidationResultForProperty(
			CustomQuestionPropertyUnderValidation.responseOptions,
		);
		const responseOptionGroupNameValidation = validationHelper.GetValidationResultForProperty(
			CustomQuestionPropertyUnderValidation.responseOptionGroupName,
		);
		const Container = sectionContainer ? sectionContainer : Section;

		return (
			<Container id='create-custom-responseoptions' sectionHeader={ContentConstants.SECTIONHEADERS_CUSTOM_QUESTION_CREATE_RESPONSEOPTION}>
				<ColFull>{ContentConstants.INSTRUCTIONALTEXT_CUSTOMQUESTION_CREATE_RESPONSEOPTION}</ColFull>
				<ColHalves
					Col1={
						<InnerSectionContainer className={'tws-response-option-group-name'} label={ContentConstants.CUSTOM_RESPONSE_OPTION_NAME}>
							<ResponseOptionGroupNameInput
								maxLength={100}
								value={this.props.name}
								onChange={this.onResponseOptionGroupNameChange}
								message={responseOptionGroupNameValidation && responseOptionGroupNameValidation.errors}
								error={
									responseOptionGroupNameValidation &&
									responseOptionGroupNameValidation.errors &&
									responseOptionGroupNameValidation.errors.length > 0
								}
							/>
						</InnerSectionContainer>
					}
					Col2={
						<TogglesContainer>
							{!isDemographic && <CustomResponseOptionGroupRankingToggle questionType={questionType} isMultiple={isMultiple} />}
							<CustomResponseOptionGroupToggle isDemographic={isDemographic} />
						</TogglesContainer>
					}
				></ColHalves>
				<ResponseOptionsWrapper>
					<CustomResponseOptionTableContainer {...this.props} validationResult={responseOptionsValidation} />
				</ResponseOptionsWrapper>
			</Container>
		);
	}

	public onResponseOptionGroupNameChange = (e: any) => {
		const { UpdateCustomResponseOptionGroupName } = this.props;
		if (UpdateCustomResponseOptionGroupName) {
			UpdateCustomResponseOptionGroupName(e.target.value);
		}
	};
}
